export const AUTH_RECOVERY_COPY = Object.freeze({
  verificationResend: 'We could not send the verification email. Please try again.',
  signup: 'We could not create your account. Please try again.',
  onboardingEmailChange: 'We could not send the confirmation email. Please try again.',
  onboardingConsent: 'We could not activate your sequences. Please try again.',
  signIn: 'Sign in failed. Please check your credentials and try again.',
  signInInvalidCredentials:
    "That email and password don't match. If you usually sign in with Google or Facebook, use that button instead, or reset your password.",
  signInRateLimited: 'Too many sign-in attempts. Wait a minute, then try again.',
  signInNetwork: "We couldn't reach the sign-in service. Check your connection and try again.",
  passwordReset: 'We could not send the password reset link. Please try again.',
  oauth: 'Authentication failed. Please try again.',
  unknown: 'Authentication failed. Please try again.',
});

/**
 * Picks sign-in copy from the Supabase auth error. Wrong email and wrong
 * password share one message so the form does not reveal which accounts exist.
 */
export const getSignInErrorCopy = (error: unknown): string => {
  const { code, status, message } = (error ?? {}) as { code?: string; status?: number; message?: string };
  const text = (message ?? '').toLowerCase();
  if (code === 'invalid_credentials' || text.includes('invalid login credentials')) {
    return AUTH_RECOVERY_COPY.signInInvalidCredentials;
  }
  if (status === 429 || code?.startsWith('over_') || text.includes('rate limit')) {
    return AUTH_RECOVERY_COPY.signInRateLimited;
  }
  if (text.includes('failed to fetch') || text.includes('network')) {
    return AUTH_RECOVERY_COPY.signInNetwork;
  }
  return AUTH_RECOVERY_COPY.signIn;
};
